import React, { Component } from 'react';
import { Form, Checkbox } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import _ from 'lodash';

import { caseInsensitiveFilter } from 'Common/GridHelper';
import { ItemEnum, CreateEditTruckRouteEnum } from 'Common/FieldEnum';
import { ReactTableColumnProperties } from 'Common/Constants';
import { TrackedCheckbox } from 'Components';

class ItemGrid extends Component {
  static propTypes = {
    dataSource: PropTypes.array.isRequired,
    siteItemsLoading: PropTypes.bool,
    filtered: PropTypes.array,
    onFilteredChange: PropTypes.func,
  };
  static defaultProps = {
    siteItemsLoading: false,
    filtered: [],
    onFilteredChange: ()=>{},
  };
  columns = [
    {
      Header: currentRows => {
        const {
          input: { value },
        } = this.props;
        const dataObjs = _.filter(
          currentRows.data,
          row => row._original[CreateEditTruckRouteEnum.IsAvailable]
        );
        const filteredData = [];
        const checkAllIds = [];
        _.forEach(dataObjs, obj => {
          const id = obj[ItemEnum.ItemId]
            ? obj[ItemEnum.ItemId]
            : obj._original[ItemEnum.ItemId];
          if (value.indexOf(id) === -1) {
            filteredData.push(id);
          } else {
            checkAllIds.push(id);
          }
        });
        return (
          <Checkbox
            style={{ marginTop: 10 }}
            checked={Boolean(
              dataObjs.length && checkAllIds.length === dataObjs.length
            )}
            onChange={(e, data) => {
              this.handleHeaderLevelCheckBox(
                filteredData,
                data.checked,
                dataObjs
              );
            }}
          />
        );
      },
      Cell: ({ original }) => {
        return (
          <div style={{ textAlign: 'center' }}>
            <TrackedCheckbox
              checked={
                this.props.input.value.indexOf(original[ItemEnum.ItemId]) !== -1
              }
              disabled={
                !original[CreateEditTruckRouteEnum.IsAvailable] &&
                original[CreateEditTruckRouteEnum.ExistingRouteDescription] !==
                  this.props.routeName
              }
              onChange={(e, data) => {
                this.handleChangeCheckbox(original, data.checked);
              }}
            />
          </div>
        );
      },
      accessor: ItemEnum.ItemId,
      ...ReactTableColumnProperties,
      sortable: false,
      filterable: false,
    },
    {
      Header: () => {
        return (
          <span>
            Item <br />
            Code
          </span>
        );
      },
      accessor: ItemEnum.ItemCode,
      ...ReactTableColumnProperties,
    },
    {
      Header: 'Description',
      accessor: ItemEnum.ItemDescription,
      width: 200,
      ...ReactTableColumnProperties,
    },
    {
      Header: 'Assigned Route',
      accessor: CreateEditTruckRouteEnum.ExistingRouteDescription,
      ...ReactTableColumnProperties,
    },
  ];

  handleHeaderLevelCheckBox = (data, checked, dataObjs) => {
    const {
      input: { value },
    } = this.props;
    const copySelected = [...value, ...data];
    if (checked) {
      this.props.input.onChange(copySelected);
    } else {
      _.forEach(dataObjs, obj => {
        const id = obj[ItemEnum.ItemId]
          ? obj[ItemEnum.ItemId]
          : obj._original[ItemEnum.ItemId];
        const index = copySelected.indexOf(id);
        if (index !== -1) {
          copySelected.splice(index, 1);
        }
      });
      this.props.input.onChange(copySelected);
    }
  };

  handleChangeCheckbox = (original, checked) => {
    const { input } = this.props;
    const formValues =
      input.value && input.value.length ? [...input.value] : [];
    const index = formValues.indexOf(original[ItemEnum.ItemId]);
    if (checked && index === -1) {
      formValues.push(original[ItemEnum.ItemId]);
    } else if (index > -1) {
      formValues.splice(index, 1);
    }
    input.onChange(formValues);
  };
  getTrProps = (state, rowInfo, column) => {
    return {
      style:
        !_.get(rowInfo, ['original', CreateEditTruckRouteEnum.IsAvailable]) &&
        _.get(rowInfo, [
          'original',
          CreateEditTruckRouteEnum.ExistingRouteDescription,
        ]) !== this.props.routeName
          ? { color: '#A9A9A9', cursor: 'not-allowed' }
          : {},
    };
  };
  render() {
    const {
      siteItemsLoading,
      dataSource,
      filtered,
      onFilteredChange,
    } = this.props;

    return (
      <Form.Field>
        <ReactTable
          defaultPageSize={20}
          showPageSizeOptions={true}
          minRows={0}
          data={dataSource}
          noDatatext={'No rows found'}
          resizable={false}
          className="-striped -highlight modalGrid"
          defaultFilterMethod={caseInsensitiveFilter}
          filtered={filtered}
          onFilteredChange={onFilteredChange}
          loading={siteItemsLoading}
          columns={this.columns}
          getTrProps={this.getTrProps}
        />
      </Form.Field>
    );
  }
}

export const ItemGridContainer = ItemGrid;



// WEBPACK FOOTER //
// ./src/pages/inventory/truckroutes/containers/createedittruckroute/ItemGridContainer.js